module.exports = __webpack_public_path__ + "img/arrow-prev-blue.b1e95da1.svg";